import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

import { SvgStyled } from './icons.styles';

export const MacIcon = forwardRef<SVGSVGElement, IconProps>(function MacIcon(
  { color = '', height = 18, width = 16, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0616 0C11.2225 1.0933 10.7775 2.16438 10.1905 2.92217C9.56242 3.73501 8.47987 4.36368 7.43098 4.33087C7.23951 3.28414 7.72976 2.20565 8.32627 1.48067C8.98064 0.680535 10.1021 0.0666777 11.0616 0ZM14.2124 15.3889C14.7532 14.5601 14.9552 14.1421 15.3749 13.2065C12.3219 12.0454 11.8327 7.70505 14.8542 6.03917C13.9326 4.88342 12.6375 4.21347 11.4151 4.21347C10.5342 4.21347 9.9307 4.44333 9.38204 4.6523C8.92482 4.82645 8.50569 4.98608 7.99593 4.98608C7.44506 4.98608 6.95724 4.81117 6.44644 4.62803C5.88515 4.42678 5.29613 4.21558 4.56523 4.21558C3.19337 4.21558 1.73313 5.05382 0.807339 6.48686C-0.494034 8.50518 -0.272054 12.2995 1.83834 15.5317C2.59265 16.6885 3.6005 17.9882 4.91871 17.9999C5.46568 18.0053 5.82966 17.842 6.22354 17.6654C6.67436 17.4632 7.16436 17.2434 8.01276 17.2389C8.86616 17.2338 9.34843 17.4562 9.79327 17.6614C10.177 17.8384 10.5329 18.0026 11.0752 17.9967C12.3945 17.9861 13.4581 16.5457 14.2124 15.3889Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
